import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import client from "../lib/api";
import RunSummary from "../components/RunSummary";

export default function RunDetail() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [run, setRun] = useState(null);
    const [error, setError] = useState("");

    useEffect(() => {
        client
            .get(`/runs/${id}`)
            .then((r) => setRun(r.data))
            .catch((e) => setError(e.response?.data?.detail || "Run not found"));
    }, [id]);

    if (error) {
        return (
            <div className="px-5 pt-8 text-center">
                <p className="text-zinc-400">{error}</p>
                <button
                    onClick={() => navigate("/app/runs")}
                    className="mt-4 text-neon-green label-cap text-xs"
                >
                    ← Back to Run Tracker
                </button>
            </div>
        );
    }
    if (!run) return <div className="p-6 text-zinc-400">Loading run...</div>;

    return <RunSummary run={run} onClose={() => navigate("/app/runs")} />;
}
